import { createGrid, themeQuartz } from 'ag-grid-community'
import { hideElement, showElement } from '../../../../helpers/generic-js/dom.js'
import { optionSelectorData } from '../../../../modules/option-selector/data.js'
import { loadDataJournals } from './load-data.js'
import { setGridContent } from './set-grid-content.js'

export const context = {
  data: {}
}

export let gridApi

const containerId = 'gridWhatHasBeenDone'

/**
 *
 */
export async function updateView () {
  console.log('----')
  console.log('updateView', arguments)
  console.log('optionSelectorData', optionSelectorData)
  showElement('statementLoadingMessage')
  hideElement('statementContainer')

  // Params in use
  context.showOrgId = optionSelectorData.organisationId || context.showOrgId
  context.currencySymbol = optionSelectorData.currencySymbol || 'XXX'
  context.viewDecimals = optionSelectorData.decimals || 0
  context.filterDates = optionSelectorData.filterDates
  context.optionsJournals = optionSelectorData.optionsJournals
  // context.groupings = ['accounts', 'tracking1', 'tracking2']

  // Load data
  // TODO: we should not need to reload if it's optionsJournals which changed
  const response = await loadDataJournals(context)
  console.log('context', context)
  context.data = response

  const gridContent = setGridContent(context)

  const gridContainerElement = document.getElementById(containerId)

  if (gridApi && gridContainerElement.innerHTML) {
    gridApi.updateGridOptions({
      rowData: gridContent.rows,
      columnDefs: gridContent.columnDefs
    })
  } else {
    const gridOptions = {
      rowData: gridContent.rows,
      columnDefs: gridContent.columnDefs,
      defaultColDef: {
        filter: true,
        floatingFilter: true
      },
      autoSizeStrategy: {
        type: 'fitCellContents'
      },
      context,
      theme: themeQuartz
    }

    gridApi = createGrid(gridContainerElement, gridOptions)
  }

  console.log('gridApi', gridApi)

  hideElement('statementLoadingMessage')
  showElement('statementContainer')
}
